import { useSettingStore } from '@/store/modules'
import { onBeforeMount, onBeforeUnmount, onMounted } from 'vue'

// 设备宽度断点配置，遵循主流响应式标准
const DEVICE_WIDTHS = {
  mobileWidth: 767,      // 手机最大宽度
  tabletMinWidth: 768,  // 平板最小宽度
  tabletMaxWidth: 1024, // 平板最大宽度
}

// 设备类型常量
const DEVICE = {
  MOBILE: 'mobile',
  IPAD: 'ipad',
  PC: 'pc',
}

function debounce(fn, delay = 200) {
  let timer = null
  return function (...args) {
    if (timer) clearTimeout(timer)
    timer = setTimeout(() => {
      fn.apply(this, args)
    }, delay)
  }
}

/**
 * 设备类型判断 hooks，自动根据窗口宽度更新 settingStore.device
 */
export function useDevice() {
  const { mobileWidth, tabletMinWidth, tabletMaxWidth } = DEVICE_WIDTHS

  const settingStore = useSettingStore()

  const getDeviceWidth = () => {
    const rect = document.body.getBoundingClientRect()
    return rect.width
  }

  const isMobile = (width) => width <= mobileWidth
  const isIpad = (width) => width >= tabletMinWidth && width <= tabletMaxWidth
  const isPc = (width) => width > tabletMaxWidth

  const resizeHandler = () => {
    // 页面隐藏时不处理
    if (document.hidden) return
    const width = getDeviceWidth()
    let device = settingStore.device
    if (isMobile(width)) {
      device = DEVICE.MOBILE
    } else if (isIpad(width)) {
      device = DEVICE.IPAD
    } else if (isPc(width)) {
      device = DEVICE.PC
    }
    if (settingStore.device !== device) {
      console.log("当前设备:", device);
      settingStore.updateSettings({ device })
    }
  }

  const debouncedResizeHandler = debounce(resizeHandler, 200)

  onBeforeMount(() => {
    resizeHandler()
    window.addEventListener('resize', debouncedResizeHandler)
  })
  onBeforeUnmount(() => {
    window.removeEventListener('resize', debouncedResizeHandler)
  })
  onMounted(() => {
    resizeHandler()
  })
}

/**
 * 获取设备宽度断点和设备类型常量
 */
export function getDeviceConstants() {
  return {
    DEVICE_WIDTHS,
    DEVICE,
  }
}
